import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'currencySymbol',
})
export class CurrencySymbolPipe implements PipeTransform {
  constructor(private readonly currencyPipe: CurrencyPipe) {}

  transform(value: number, currency: string): string {
    const formattedCurrency = this.currencyPipe.transform(0, currency, 'symbol-narrow', '1.0-0');
    return formattedCurrency.replace(/\d/g, '').trim();
  }
}
